'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'diagram-subtask';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e479';
var svgPathData = 'M448 64c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-304 0-32 0-48 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l384 0zM144 224l304 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l48 0 0 96c0 44.2 35.8 80 80 80l32 0 0 16c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-160 0c-35.3 0-64 28.7-64 64l0 16-32 0c-26.5 0-48-21.5-48-48l0-96zm304 96c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiagramSubtask = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;